import React, { Component } from "react";
import { API } from "aws-amplify";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import  Moment  from 'moment';
import "./Home.css";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdminUser: false,
      isLoading: true,
      license: []
    };
  }

  async componentDidMount() {
    
    if (!this.props.isAuthenticated) {
      return;
    }

    if (this.props.isAdminUser) {
      this.setState({ isAdminUser: true });;
    }

    try {
      const license = await this.license();
      this.setState({ license });
    } catch (e) {
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  license() {
    return API.get("license", "/license");
  }

  createData(key, value) {
    return { key, value };
  }

  renderLicenseAttributes(license) {
    const StyledTable  = makeStyles(theme => ({
      root: {
        width: '100%',
      },
      paper: {
        marginTop: theme.spacing(3),
        width: '100%',
        overflowX: 'auto',
        marginBottom: theme.spacing(2),
      },
      table: {
        minWidth: 650,
      },
    }));
    const StyledTableRow = withStyles(theme => ({
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.background.default,
        },
      },
    }))(TableRow);
    const StyledTableCell = withStyles(theme => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
      },
      body: {
        fontSize: 14,
      },
    }))(TableCell);

    const rows = []
    rows[0] = this.createData('License Id',license.licenseId);
    rows[1] = this.createData('Organisation', license.licensedTo);
    rows[2] = this.createData('License Type', license.category);
    rows[3] = this.createData('License Expiry', Moment(license.licenseEndDate).format('MMMM Do YYYY'));
    rows[4] = this.createData('Email', license.email);
    if (this.state.isAdminUser) {
      rows[5] = this.createData('Assigned Licenses', license.assignedLicenses);
      rows[6] = this.createData('Allocated Licenses', license.allocatedLicenses);
      rows[7] = this.createData('CmdLine License Key', license.cmdlineLicenseKey);
    }
    return (
      <Paper className={StyledTable.root}>
          <Table className={StyledTable.table} aria-label="simple table" style={{overflow:'wrap'}}> 
          <TableHead>
            <TableRow>
              <StyledTableCell width="200">Fields</StyledTableCell>
              <StyledTableCell width="auto">Values</StyledTableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {rows.map(row => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.key}
              </StyledTableCell >
              <StyledTableCell align="left" style={{ maxWidth:"700px", whiteSpace: "normal", overflowWrap: "break-word" }}>{row.value}</StyledTableCell >
            </StyledTableRow >
            ))}
        </TableBody>      
        </Table>
      </Paper>
    );
  }

  renderLicenseDetails() {
    return (
      <div>
      <div className="content">
        <h2>DataStar License</h2>
        <p>The information about your software license is as described in the table below. This information can be useful when modifying, troubleshooting, or upgrading your system.</p>
      </div>
        <div>
          {!this.state.isLoading && this.renderLicenseAttributes(this.state.license)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="root">
        {this.props.isAuthenticated ? this.renderLicenseDetails() : <div/>}
      </div>
    );
  }
}